// «Страница не найдена» (FR-036; contracts/ui.md, «Маршруты и экраны»): вошедший пользователь
// видит её внутри каркаса — с меню, шапкой, поиском и «Создать ▾», без сеанса — отдельным
// экраном. Неизвестный адрес верхнего уровня (/net-takogo) не входит ни в один маршрут каркаса,
// и маршрутизатор отдаёт его корню, поэтому каркас здесь собирается сам. Внутри каркаса
// (вложенный адрес) — только сама страница, второго каркаса нет. Без ролей каркас тот же, что у
// главной «Нет доступа»: правило «в сеансе» (FR-011а).
import { useDelayedFlag } from '@kp/ui';
import { useQuery } from '@tanstack/react-query';
import { NotFoundScreen } from '../app/ErrorScreens.tsx';
import { AppShell } from './AppShell.tsx';
import { useInShell } from './context.tsx';
import { meQuery } from './session.ts';
import { ShellSkeleton } from './ShellSkeleton.tsx';

export function NotFoundPage() {
  const inShell = useInShell();
  // Сеанс — тот же запрос /api/auth/me, что у каркаса; нет сеанса — без повтора и окна входа.
  const session = useQuery({ ...meQuery(), enabled: !inShell, retry: false });
  // Ответ обычно уже в кэше; ждать дольше 0,3 с — заглушка каркаса, а не пустой экран (FR-040а).
  const waiting = useDelayedFlag(!inShell && session.isPending);
  if (inShell) return <NotFoundScreen />;
  if (session.isPending) return waiting ? <ShellSkeleton /> : null;
  // Вошедший — в каркасе, даже без ролей: сеанс сам даёт меню «Главная · Замещения», профиль и
  // уведомления (правило «в сеансе», FR-011а) — как у маршрута каркаса (_app, NoAccessScreen).
  if (session.data) {
    return (
      <AppShell>
        <NotFoundScreen />
      </AppShell>
    );
  }
  return <NotFoundScreen />;
}
